import { render, staticRenderFns } from "./CreatedBill.vue?vue&type=template&id=64688981&scoped=true"
import script from "./CreatedBill.vue?vue&type=script&lang=js"
export * from "./CreatedBill.vue?vue&type=script&lang=js"
import style0 from "./CreatedBill.vue?vue&type=style&index=0&id=64688981&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64688981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64688981')) {
      api.createRecord('64688981', component.options)
    } else {
      api.reload('64688981', component.options)
    }
    module.hot.accept("./CreatedBill.vue?vue&type=template&id=64688981&scoped=true", function () {
      api.rerender('64688981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/CreatedBill.vue"
export default component.exports